import { render, staticRenderFns } from "./RoleDetailsModal.vue?vue&type=template&id=bb444bd8&scoped=true&"
import script from "./RoleDetailsModal.vue?vue&type=script&lang=js&"
export * from "./RoleDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./RoleDetailsModal.vue?vue&type=style&index=0&id=bb444bd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb444bd8",
  null
  
)

export default component.exports